module.exports = __webpack_public_path__ + "static/mapbox-zoom-d74f2af453ee516c1c6721c5edc31df4.gif";